import { createSlice } from "@reduxjs/toolkit";

const transactionSlice = createSlice({
  name: "transaction",
  initialState: {
    list: []
  },
  reducers: {
    addTransaction(state, action) {
      state.list.push({
        id: action.payload.id,
        hash: action.payload.hash,
        message: action.payload.message || "",
        status: action.payload.status || "pending"
      })
    },

    updateTransaction(state, action) {
      const transaction = state.list.find(tx => tx.id === action.payload.id);
      if (transaction) {
        transaction.status = action.payload.status;
      }
    },

    updateTransactionByHash(state, action) {
      const transaction = state.list.find(tx => tx.hash === action.payload.hash);
      if (transaction) {
        transaction.status = action.payload.status;
        if (action.payload.message) {
          transaction.message = action.payload.message;
        }
      }
    },

    removeTransaction(state, action) {
      state.list = state.list.filter(tx => tx.id !== action.payload.id)
    },
  }
});

export const {addTransaction, updateTransaction, updateTransactionByHash, removeTransaction} = transactionSlice.actions;
export default transactionSlice.reducer;